import { render, staticRenderFns } from "./ListBuildingPositionLacks.vue?vue&type=template&id=ad22166e&"
import script from "./ListBuildingPositionLacks.vue?vue&type=script&lang=js&"
export * from "./ListBuildingPositionLacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports